import { render, staticRenderFns } from "./PartsOfSpeech.vue?vue&type=template&id=4e123409&lang=pug&"
import script from "./PartsOfSpeech.vue?vue&type=script&lang=js&"
export * from "./PartsOfSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports